export default "__VITE_ASSET__CBgTSPA___"